import { Link, useLocation } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

/**
 * MarketingCtaBar — sticky bottom conversion bar for anonymous visitors
 * on the marketing pages, mobile only.
 *
 * Why this exists: on mobile the navbar collapses to a hamburger, so an
 * anon visitor scrolling a long marketing page has NO always-visible
 * signup affordance between the hero and the next in-page CTA band. This
 * pins the primary action to the bottom of the viewport the whole way
 * down. Hidden at md+ where the navbar carries a persistent "Start free"
 * button instead (see Navbar.tsx), and never rendered for signed-in
 * users or inside the native Pro Capacitor shell (Layout gates all
 * three). Audience-aware target: pros on /pro get the pro trial, every
 * other marketing surface gets the golfer free-bag signup.
 */
export function MarketingCtaBar() {
  const location = useLocation();
  const isProSurface = location.pathname === '/pro' || location.pathname.startsWith('/pro/');

  const target = isProSurface
    ? '/pro/register?source=mobile_cta_bar'
    : '/customer/register?source=mobile_cta_bar';
  const label = isProSurface ? 'Start your free trial' : 'Build my bag, free';
  const subLabel = isProSurface ? '2 months free · No card' : '2 months Premium free · No card';

  return (
    <div
      className="md:hidden fixed inset-x-0 bottom-0 z-40 border-t backdrop-blur"
      style={{
        backgroundColor: 'color-mix(in srgb, var(--color-surface) 92%, transparent)',
        borderColor: 'var(--color-border)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <div className="px-4 py-3">
        <Link
          to={target}
          className="w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl text-white font-bold text-base shadow-lg transition-[filter] hover:brightness-110"
          style={{ backgroundColor: 'var(--color-brand)' }}
        >
          {label}
          <ArrowRight className="w-5 h-5" />
        </Link>
        <p
          className="text-[11px] text-center mt-1.5"
          style={{ color: 'var(--color-on-subtle)' }}
        >
          {subLabel}
        </p>
      </div>
    </div>
  );
}

export default MarketingCtaBar;
